module.exports = __webpack_public_path__ + "static/media/TN-Men-Shirts-v2.0-OA.f0ba1b8b.svg";